import { render } from "./MfaVerifyCode.vue?vue&type=template&id=31bb4b65"
import script from "./MfaVerifyCode.vue?vue&type=script&lang=js"
export * from "./MfaVerifyCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__